import { FileText, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface CVViewerProps {
  cv: string | null;
  cvExists: boolean;
  onView: () => void;
  onUpload?: () => void;
  showUploadZone?: boolean;
}

export const CVViewer = ({ cv, cvExists, onView, onUpload, showUploadZone = false }: CVViewerProps) => {
  const { t } = useTranslation();

  // Use cvExists from the database check to determine if CV is available
  // If the upload zone is visible, don't show the CVViewer content at all
  if (showUploadZone) {
    return null;
  }

  // No CV exists
  if (!cvExists) {
    return (
      <div className="text-center p-4">
        <FileText className="h-12 w-12 text-gray-400 mx-auto mb-2" />
        <p className="text-gray-500 text-sm mb-4">{t("candidates.cv.noCV")}</p>
        {onUpload && (
          <Button
            variant="outline"
            onClick={onUpload}
            className="flex items-center gap-2"
          >
            <Upload className="h-4 w-4" />
            {t("candidates.cv.uploadCV")}
          </Button>
        )}
      </div>
    );
  }

  // CV exists, show view button

  let cvText = decodeURIComponent(cv.split('/').pop() || '');
  console.log("CV Text:", cvText);

  return (
    <Button
      variant="ghost"
      onClick={onView}
      className="flex flex-col items-center gap-2 h-auto p-4 w-full"
    >
      <FileText className="h-12 w-12 text-blue-500" />
      <p className="text-xs text-gray-500 whitespace-normal break-words text-center w-full">
        {t("candidates.cv.clickToView", { filename: cvText })}
      </p>
    </Button>
  );
};
